import { useGomonAPI } from "../../Hooks/GomonApiHook";
import * as GomonTypes from "../../types/gomonTypes";

export interface FormattedV2Site {
  Name: string;
  fullName: string;
  label: string;
  _id: string;
  name: string;
  company_id?: string;
  company_name?: string;
  features?: Record<string, boolean>;
  location?: { type?: string; coordinates?: number[] };
  tags?: string[];
}

export function useV2Sites() {
  const { sites } = useGomonAPI();
  const query = sites.list.useQuery({}, {
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  return {
    sites: (query.data?.sites as GomonTypes.Site[]) || [],
    loading: query.isLoading || query.isFetching,
    error: query.error ? query.error.message : null,
    fetchSites: query.refetch,
  };
}

export function formatV2SiteLists(sites: GomonTypes.Site[]): FormattedV2Site[] {
  if (!Array.isArray(sites)) return [];

  const sorted = [...sites].sort((a, b) => a.name.localeCompare(b.name));

  const formatted: FormattedV2Site[] = sorted.map((i) => ({
    _id: i._id,
    name: i.name,
    company_id: i.company_id,
    company_name: i.company_name,
    features: i.features,
    location: i.location,
    tags: i.tags,
    Name: i.name,
    fullName: `${i.name} (${i.company_name || ""})`,
    label: `${i.name} (${i.company_name || ""})`,
  }));

  if (!formatted.some((i) => i.name === "All")) {
    formatted.push({
      _id: "all",
      name: "All",
      company_id: "",
      company_name: "All Sites",
      features: { nszd: false },
      location: { type: "Point", coordinates: [0, 0] },
      tags: [],
      Name: "All",
      fullName: "All (All Sites)",
      label: "All (All Sites)",
    });
  }

  return formatted;
}